import React from "react";

/** Ponesi Coin — single source of truth for the coin symbol across the whole app.
 * Uses the approved `Ponesi coin new` master (tightly cropped PNG derivative, never redrawn). */
export function PonesiCoinIcon({ size = 16, className = "", title = "Ponesi Coins" }) {
  return (
    <img
      src="/partner-coin-64.png?v=3"
      srcSet="/partner-coin-64.png?v=3 1x, /partner-coin-128.png?v=3 2x"
      width={size}
      height={size}
      role="img"
      alt={title}
      className={`inline-block shrink-0 align-[-0.15em] ${className}`}
      style={{ objectFit: "contain" }}
    />
  );
}

/** Coin amount with the icon, e.g. `[coin] 1.400`. */
export function Coins({ value, size = 14, className = "", bold = true, testid }) {
  const n = Number(value || 0);
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 ${className}`}>
      <PonesiCoinIcon size={size} />
      <span className={bold ? "font-bold tabular-nums" : "tabular-nums"}>
        {new Intl.NumberFormat("sr-RS").format(Math.round(n))}
      </span>
    </span>
  );
}
